exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".archive[data-v-61ee8c74]{padding:58px 0 110px}.archive__pages[data-v-61ee8c74],.archive__status[data-v-61ee8c74]{margin-top:48px}", ""]);

// exports
